import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import MissingLabel from 'automation-ui-core/components/MissingLabel';
import FormattedTimeDelay from 'automation-ui-action-features/components/delay/FormattedTimeDelay';
import { translateToSegmentationFiltersFormat } from 'automation-ui-action-features/actions/wait-until/utils/waitUntilSegmentationFiltersUtils';
import WaitUntilSegmentationFilters from 'automation-ui-action-features/actions/wait-until/WaitUntilSegmentationFilters';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function WaitUntilActionExplainer({
  action,
  getActionLabelById,
  flowObjectTypeId
}) {
  const metadata = action.metadata;
  const {
    expiration
  } = metadata;
  const duration = /*#__PURE__*/_jsx("strong", {
    children: /*#__PURE__*/_jsx(FormattedTimeDelay, {
      timeDelay: expiration
    })
  });
  const sourceActionId = metadata.getTargetActionId();
  const filterBranch = translateToSegmentationFiltersFormat(metadata.getEventFilters());
  let text;
  if (sourceActionId) {
    const sourceActionHeaderTitle = sourceActionId && getActionLabelById({
      actionId: sourceActionId
    });
    text = /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "automation-ui-action-features.action-features.wait-until.explainer.other-object-with-segmentation-filters",
      options: {
        duration,
        sourceObjectName: /*#__PURE__*/_jsx("strong", {
          children: sourceActionHeaderTitle || /*#__PURE__*/_jsx(MissingLabel, {
            type: "event"
          })
        })
      }
    });
  } else {
    text = /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "automation-ui-action-features.action-features.wait-until.explainer.enrolled-object-with-segmentation-filters",
      options: {
        duration
      }
    });
  }
  return /*#__PURE__*/_jsxs("div", {
    "data-test-id": "wait-until-action-explainer",
    children: [text, /*#__PURE__*/_jsx(WaitUntilSegmentationFilters, {
      objectTypeId: flowObjectTypeId,
      triggers: filterBranch,
      readOnly: true
    })]
  });
}